<template>
  <div class="isTxt" v-if="isTxt">
    {{ innerValue + innerValueAddress || '-' }}
  </div>
  <div class="phone-box" v-else-if="phoneEmpty">
    <RxkInput
      style="width: 100%"
      v-model="innerValue"
      :disabled="renderConfig.disabled"
      :placeholder="renderConfig.placeholder"
      :maxlength="11"
      @input="handleInput"
      @blur="handleBlur"
    />
    <RxkButton @click="handleCheckEmpty" style="margin-left: 8px; color: #5687ff">
      空号校验
    </RxkButton>
  </div>
  <div class="phone-box" v-else-if="phoneCode">
    <div style="width: 100%">
      <RxkInput
        style="width: 100%"
        v-model="innerValue"
        :disabled="renderConfig.disabled"
        :placeholder="renderConfig.placeholder"
        :maxlength="11"
        @blur="handleBlur"
        @input="handleInput"
      />
      <div style="display: flex; margin-top: 8px">
        <RxkInput style="flex: 1" placeholder="短信验证码" />
        <RxkButton style="margin-left: 8px; color: #5687ff">发送验证码</RxkButton>
      </div>
    </div>
  </div>
  <div class="phone-box" v-else>
    <RxkInput
      style="width: 100%"
      v-model="innerValue"
      :disabled="renderConfig.disabled"
      :placeholder="renderConfig.placeholder"
      :maxlength="11"
      @input="handleInput"
      @blur="handleBlur"
    />
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkInput } from '@/components/common/RxkInput'
import { operateListEnum } from '@/enums/preObjectManage'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { checkNumberApi } from '@/apis/callCenter/callCenter'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'blur'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})

// 回显电话的省份
const innerValueAddress = computed(() => {
  let fieldCode = props.data?.columnInfo?.fieldCode
  let phoneRegionInfo = props.subFieldFormData?.phoneRegionInfo || []
  if (fieldCode === 'primaryContactPhone' || fieldCode === 'linkPhone') {
    return phoneRegionInfo.find((f: any) => f.fileCode === fieldCode)?.region
      ? ` (${phoneRegionInfo.find((f: any) => f.fileCode === fieldCode)?.region})`
      : ''
  } else {
    return ''
  }
})

const phoneEmpty = computed(() => {
  const columnOperateList = props.data.columnOperateList || []
  const current = columnOperateList.find(
    (item: Recordable) => item.code === operateListEnum.PHONE_EMPTY && item.value
  )
  return !!current
})

const phoneCode = computed(() => {
  const columnOperateList = props.data.columnOperateList || []
  const current = columnOperateList.find(
    (item: Recordable) => item.code === operateListEnum.PHONE_CODE && item.value
  )
  return !!current
})

function handleInput(val) {
  innerValue.value = val.replace(/[^\d]/g, '')
}
function handleBlur() {
  emit('blur', innerValue.value)
}

function handleCheckEmpty() {
  checkNumberApi({
    phone: unref(innerValue)
  }).then(() => {
    ElMessage.success('校验成功')
  })
}

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>
<style lang="scss" scoped>
.phone-box {
  display: flex;
  width: 100%;
}
</style>
